import * as React from 'react';

export interface QuickActionConfig {
  key: string;
  icon: string;
  title: string;
  description: string;
  cta: string;
  tone: 'violet' | 'blue' | 'green';
  loading?: boolean;
  onClick: () => void;
}

const TONES: Record<QuickActionConfig['tone'], { tint: string; solid: string }> = {
  violet: { tint: 'rgba(99, 102, 241, 0.14)', solid: '#6366f1' },
  blue: { tint: 'rgba(14, 165, 233, 0.14)', solid: '#0ea5e9' },
  green: { tint: 'rgba(16, 185, 129, 0.14)', solid: '#10b981' },
};

/**
 * Modern quick-action tiles: colourful icon chips, a clear CTA, and a hover
 * lift. Each tile is fully clickable.
 */
const QuickActions: React.FC<{ actions: QuickActionConfig[] }> = ({ actions }) => {
  return (
    <div className="qa-grid">
      {actions.map((action) => {
        const tone = TONES[action.tone];
        return (
          <button
            key={action.key}
            type="button"
            className="qa-tile"
            onClick={action.onClick}
            disabled={action.loading}
            aria-label={`${action.title}. ${action.description}`}
          >
            <span className="qa-icon" style={{ background: tone.tint, color: tone.solid }}>
              {action.loading ? <s-spinner size="base" /> : <s-icon type={action.icon} />}
            </span>
            <span className="qa-body">
              <s-text type="strong">{action.title}</s-text>
              <s-text color="subdued">{action.description}</s-text>
            </span>
            <span className="qa-cta" style={{ color: tone.solid }}>
              {action.cta}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickActions;
